export const overlay = document.getElementById('overlay');
export const terminal = document.getElementById('terminal');
export const editor = document.querySelector(
  '#options .editor',
) as HTMLIFrameElement;
